import { Map, Navigation, Camera, Mic, ListChecks, Barcode } from "lucide-react";

export const Solutions = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          We made this app to solve your problems
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Google Maps Integration */}
          <div className="bg-white p-6 rounded-lg shadow-md animate-fade-in">
            <div className="flex items-center mb-4">
              <Map className="w-6 h-6 text-primary mr-3" />
              <h3 className="text-xl font-semibold text-gray-900">Google Maps Integration</h3>
            </div>
            <p className="text-gray-600">
              Explain how Dynamico incorporates Google Maps for location-based data.
            </p>
          </div>

          {/* GPS Locations */}
          <div className="bg-white p-6 rounded-lg shadow-md animate-fade-in" style={{ animationDelay: "0.1s" }}>
            <div className="flex items-center mb-4">
              <Navigation className="w-6 h-6 text-primary mr-3" />
              <h3 className="text-xl font-semibold text-gray-900">GPS Locations</h3>
            </div>
            <p className="text-gray-600">
              Highlight the ability to capture precise geographical coordinates.
            </p>
          </div>

          {/* Camera Integration */}
          <div className="bg-white p-6 rounded-lg shadow-md animate-fade-in" style={{ animationDelay: "0.2s" }}>
            <div className="flex items-center mb-4">
              <Camera className="w-6 h-6 text-primary mr-3" />
              <h3 className="text-xl font-semibold text-gray-900">Camera Integration</h3>
            </div>
            <p className="text-gray-600">
              Showcase the feature that allows users to take photos and videos directly within forms.
            </p>
          </div>

          {/* Microphone for Voice Recording */}
          <div className="bg-white p-6 rounded-lg shadow-md animate-fade-in" style={{ animationDelay: "0.3s" }}>
            <div className="flex items-center mb-4">
              <Mic className="w-6 h-6 text-primary mr-3" />
              <h3 className="text-xl font-semibold text-gray-900">Microphone for Voice Recording</h3>
            </div>
            <p className="text-gray-600">
              Describe how voice notes can be recorded within forms.
            </p>
          </div>

          {/* Business Logic and Approval Paths */}
          <div className="bg-white p-6 rounded-lg shadow-md animate-fade-in" style={{ animationDelay: "0.4s" }}>
            <div className="flex items-center mb-4">
              <ListChecks className="w-6 h-6 text-primary mr-3" />
              <h3 className="text-xl font-semibold text-gray-900">Business Logic and Approval Paths</h3>
            </div>
            <p className="text-gray-600">
              Explain the customizable workflows and approval processes.
            </p>
          </div>

          {/* Barcode Scanning */}
          <div className="bg-white p-6 rounded-lg shadow-md animate-fade-in" style={{ animationDelay: "0.5s" }}>
            <div className="flex items-center mb-4">
              <Barcode className="w-6 h-6 text-primary mr-3" />
              <h3 className="text-xl font-semibold text-gray-900">Barcode Scanning</h3>
            </div>
            <p className="text-gray-600">
              Mention the ease of inputting data using barcodes.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};